/* eslint-disable no-unused-vars */
import Button, { ButtonProps } from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import { forwardRef, useState } from 'react';

import { MenuItemData } from '../definitions';
import { nestedMenuItemsFromObject } from './nestedMenuItemsFromObject';
import more_horiz from '../../assets/more_horiz.svg';
import { AgColor } from '../../Styles/AgColor';
import { styleMappings } from '../../Styles/AgTypography';

interface NestedDropdownProps {
    children?: React.ReactNode;
    menuItemsData?: MenuItemData;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    ButtonProps?: Partial<ButtonProps>;
    MenuProps?: Partial<MenuProps>;
}

export const NestedDropdown = forwardRef<HTMLDivElement | null, NestedDropdownProps>(function NestedDropdown(
    props,
    ref
) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const { disabled, menuItemsData: data, onClick, ButtonProps, MenuProps, ...rest } = props;

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
        onClick && onClick(e);
    };
    const handleClose = () => setAnchorEl(null);

    const defaultStyle = {
      '& .MuiList-root': {
        p: 0,
        minWidth: 200,
      },
      '& li': {
        p: 2,
        borderBottom: `1px solid ${AgColor.grey3}`,
        '& > div.MuiBox-root': {
          display: 'flex',
          alignItems: 'center',
          '& > p': {
            fontFamily: 'Inter',
            ...styleMappings['AP.Paragraph.Small.SemiBold'],
          }
        }
      }
    };

    const menuItems = nestedMenuItemsFromObject({
        handleClose,
        isOpen: open,
        menuItemsData: data?.items ?? [],
        MenuProps: {
          sx: {
            ...defaultStyle,
            ...MenuProps?.sx,
          },
          ...MenuProps,
        },
    });

    return (
        <div ref={ref} {...rest}>
            <Button onClick={handleClick} sx={{ padding: '0', minWidth: '28px', marginLeft: '16px' }} disabled={disabled}>
                <img alt='' src={more_horiz} style={{ border: `1px solid ${AgColor.grey3}`, borderRadius: '4px', cursor: 'pointer', width: '28px', height: '24px' }}/>
            </Button>
            <Menu 
                anchorEl={anchorEl} 
                open={open} 
                onClose={handleClose}
                sx={{
                  ...defaultStyle,
                  ...MenuProps?.sx,
                }}
                {...MenuProps}
            >
                {menuItems}
            </Menu>
        </div>
    );
});